import { Fragment } from 'react'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format'

export function convertCurrency(amount, currency = 'USD', to, selectedCurrency) {
  return fx(amount).from(currency).to(to || selectedCurrency, fx.discount)
}

function PriceConverter({ amount, currency = 'USD', onlyNumber, to, decimals, noCurrency, selectedCurrency }) {
  const CURRENCY_CONVERTER = () => {
    let value = fx(amount).from(currency).to(to || selectedCurrency, fx.discount)

    if(onlyNumber) {
      return value
    }

    if(value >= 100000 && value < 1000000) {
      return <NumberFormat
        thousandSeparator
        displayType='text'
        prefix={noCurrency ? '' : selectedCurrency + ' '}
        suffix='K'
        decimalScale={1}
        value={value / 1000} />
    } else if(value >= 1000000 && value < 1000000000) {
      return <NumberFormat
        thousandSeparator
        displayType='text'
        prefix={noCurrency ? '' : selectedCurrency + ' '}
        suffix='M'
        decimalScale={2}
        value={value / 1000000} />
    } else if(value >= 1000000000) {
      return <NumberFormat
        thousandSeparator
        displayType='text'
        prefix={noCurrency ? '' : selectedCurrency + ' '}
        suffix='Bn'
        decimalScale={2}
        value={value / 1000000000} />
    }

    if(decimals) {
      return <NumberFormat
        thousandSeparator
        displayType='text'
        prefix={noCurrency ? '' : selectedCurrency + ' '}
        decimalScale={2}
        value={value} />
    } else {
      return <NumberFormat
        thousandSeparator
        displayType='text'
        prefix={noCurrency ? '' : selectedCurrency + ' '}
        decimalScale={0}
        value={value} />
    }
  }
  return (
    <Fragment>
      { amount && fx && fx.rates ? CURRENCY_CONVERTER() : 0 }
    </Fragment>
  )
}

export default connect(
  state => ({
    selectedCurrency: state.selectedCurrency,
  })
)(PriceConverter)
